// @core/api/endpoints/admin/get_admin_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AdminStatsResponse,
} from '../../../types/admin';

const BASE_PATH = '/admin';

/**
 * Get admin dashboard statistics
 * Returns aggregated statistics for the admin dashboard including user counts, activity metrics, and system health indicators over the specified time period.
 */
export async function GetAdminStats(
  params?: {
  },
  options?: RequestOptions
): Promise<AdminStatsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/admin/stats`;
  const requestOptions = options;
  return client.get<AdminStatsResponse>(requestPath, { ...requestOptions, params });
}
